module.exports = __webpack_public_path__ + "static/media/map-pin.7af85278.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/map-pin.svg
// module id = 590
// module chunks = 0